import React from "react";
import { servicesData, industriesData, advisoryData, performanceValue, globalExpansion,  } from "../data/servicesData";
import "./ServicesStyle.css";

function Services() {
  return (
    <div className="services-container">
      <h1>What we do</h1>
      <p className="intro">

      Lifting investments to new heights. We don't just invest — we guide, nurture, and elevate ventures to realize their full potential
  </p>

      {/* Services Section */}

<section className="industries-section">
  <h2>Core Investment Services</h2>
      <div className="services-grid">
        {servicesData.map((service) => (
          <div key={service.id} className="service-card">
           {/*  <img src={service.image} alt={service.title} className="service-image" /> */}
            <h3>{service.title}</h3>
            {service.description}
          </div>
        ))}
      </div>

</section>

       {/* advisory services */}
<section className="industries-section">
  <h2>Structuring & Advisory Services</h2>
  <div className="industries-grid">
    {advisoryData.map((advisory) => (
      <div key={advisory.id} className="industry-card">
        {/*  <img src={advisory.image} alt={advisory.name} className="industry-image" />*/}
        <h4>{advisory.name}</h4>
       {advisory.description}
      </div>
    ))}
  </div>
</section>

       {/* advisory services */}
<section className="industries-section">
  <h2>Global Strategy & Expansion</h2>
  <div className="industries-grid">
    {globalExpansion.map((global) => (
      <div key={global.id} className="industry-card">
        {/*  <img src={global.image} alt={global.name} className="industry-image" />*/}
        <h4>{global.name}</h4>
       {global.description}
      </div>
    ))}
  </div>
</section>





    </div>
  );
}

export default Services;
